import vue from 'vue'
import header from '@/components/common/header.vue'

vue.component('wit-header',header)
